import { useRouter } from 'next/navigation';
import { TableCell, TableRow } from '@mui/material';

import { ProcessedName } from '~/shared';
import { CampaignProductReport } from '~/types';

export type SponsoredProductsReportCampaignRowProps = {
  resume: CampaignProductReport;
  advertiserId: string;
  campaignId: string;
};

export function SponsoredProductsReportCampaignRow({
  resume,
  advertiserId,
  campaignId,
}: SponsoredProductsReportCampaignRowProps) {
  const router = useRouter();

  function handleClick() {
    if (!resume.sku) return;
    router.push(
      `/patrocinados/relatorios/${advertiserId}/${campaignId}/${resume.sku}`
    );
  }

  const productName = resume.nome?.trim() || 'Produto Indisponível';

  return (
    <TableRow
      key={`${advertiserId}_${campaignId}`}
      sx={{
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        '&:hover': {
          '.MuiTableCell-body': {
            backgroundColor: theme => theme.palette.grey[100],
          },
        },
        '.MuiTableCell-body': {
          backgroundColor: 'background.paper',
        },
      }}
    >
      <TableCell
        component="th"
        scope="row"
        sx={{
          position: 'sticky',
          left: 0,
          maxWidth: '300px',
          whiteSpace: 'normal',
          wordBreak: 'break-word',
        }}
        onClick={handleClick}
      >
        <ProcessedName name={productName} />
      </TableCell>

      <TableCell component="th" scope="row" onClick={handleClick}>
        {resume.sku ?? '-'}
      </TableCell>
      <TableCell component="th" scope="row" onClick={handleClick}>
        {resume.clicks ?? '-'}
      </TableCell>
      <TableCell component="th" scope="row" onClick={handleClick}>
        {resume.impressions ?? '-'}
      </TableCell>
      <TableCell component="th" scope="row" onClick={handleClick}>
        {resume.ctr ?? '-'}
      </TableCell>
      <TableCell component="th" scope="row" onClick={handleClick}>
        {resume.cpm ?? '-'}
      </TableCell>
      <TableCell component="th" scope="row" onClick={handleClick}>
        {resume.cpc ?? '-'}
      </TableCell>
    </TableRow>
  );
}
